const app = {
    modal: {
        close: 'Fermer',
        ok: 'OK',
        cancel: 'Annuler',
        save: 'Enregistrer',
        saving: 'Enregistrement...',
    },
    products: {
        title: 'Produits',
        new: 'Nouveau',
        all: 'Tous les produits',
        sizes: '',
        excludeVAT: 'HT',
        startDesign: 'Commencer le design',
        searchResults: 'Résultats de recherche pour &quot;<strong>{query}</strong>&quot;',
        noResults: 'Aucun produit trouvé',
        showInShop: 'Afficher le produit dans votre magasin',
        connectProduct: 'Connecter le produit TiB',
        connectProductId: 'ID produit Shopify',
        regionFilter: {
            allRegions: 'Toutes les régions',
            europe: 'Europe & Reste du monde',
            america: 'Amérique du Nord & Sud',
            mixedCurrencyInfo:
                "Les produits fabriqués exclusivement dans notre site aux États-Unis ou exclusivement dans notre site en Europe n'ont qu'un seul prix, dans la devise du site concerné ($ ou €). Les produits fabriqués sur les deux sites affichent donc deux prix. La facturation s'effectue toujours dans la devise du site de production concerné.",
        },
    },
    tibProductConnect: {
        error: {
            title: "Le produit n'a pas pu être connecté",
            variantNotFound: "Les variantes suivantes n'ont pas pu être trouvées:\n",
        },
        success: {
            title: 'Produit connecté avec succès',
        },
    },
    mainShop: {
        title: 'Mon magasin',
    },
    orders: {
        title: 'Commandes',
        personalized: 'Commandes personnalisées',
        notEu: 'Commandes hors UE',
        personalizedShort: 'Personnalisé',
        notEUShort: 'Non-UE',
        addressMissing: 'Adresse manquante',
        all: 'Tous',
        splittedOrders: 'Une partie de cette commande:',
    },
    myStores: {
        title: 'Mes Boutiques',
        storeRegion: 'Région de la boutique',
        billingCurrency: 'Devise de facturation',
        activeButton: 'Actif',
        inactiveButton: 'Inactif',
        viewStoreButton: 'Voir la boutique',
        editStoreDetailsButton: 'Modifier les détails de la boutique',
        addProductButton: 'Ajouter un produit',
        title2: 'Connecter une nouvelle boutique',
        subtitle2:
            "Il est un fait établi depuis longtemps qu'un lecteur sera distrait par le contenu lisible d'une page en regardant sa mise en page.",
        connectButton: 'Connecter',
        brandDescriptions: {
            shopify:
                'Shopify est un choix attrayant pour les petites entreprises, offrant une plateforme complète avec des outils faciles à utiliser et des prix abordables.',
            woocommerce:
                'WooCommerce est une plateforme e-commerce établie et puissante basée sur WordPress, offrant de nombreuses possibilités de personnalisation.',
            amazon: 'Amazon est un choix attrayant pour les petites entreprises, offrant une plateforme complète avec des outils faciles à utiliser et des prix abordables.',
            etsy: "Etsy offre un moyen facile et rapide de commencer à vendre et d'entrer en contact avec des millions d'acheteurs actifs dans le monde entier, ce qui en fait un choix idéal pour les nouveaux vendeurs.<br><br>The term 'Etsy' is a trademark of Etsy, Inc. This application uses the Etsy API but is not endorsed or certified by Etsy, Inc.",
            tiktok: "TikTok Shop est idéal pour les vendeurs qui souhaitent tirer parti du commerce social, en combinant le divertissement de TikTok avec une expérience d'achat fluide pour toucher un public très engagé.<br><br>Caractéristiques : Accès à un public jeune et dynamique de plus d'1 milliard d'utilisateurs actifs &middot; Intégration transparente avec le contenu TikTok &middot; Outils intégrés pour le shopping en direct et les achats in-app.",
        },
        woocommerce: {
            modalTitle: 'Connecter une boutique WooCommerce',
            modalDescription:
                "Entrez l'URL de votre boutique WooCommerce. Vous serez ensuite redirigé vers votre boutique pour approuver l'accès MarketPrint.",
            modalConnect: 'Continuer',
            shopUrlLabel: 'URL de la boutique',
            shopUrlPlaceholder: 'https://maboutique.fr',
            shopUrlHint: "L'URL complète de votre boutique WooCommerce, y compris https://",
            modalInfo:
                "Vous serez redirigé vers votre installation WooCommerce et devrez y approuver l'accès pour MarketPrint. Assurez-vous d'être connecté à votre boutique WooCommerce.",
        },
        learnMoreLink: 'En savoir plus',
        noShops: "Il n'y a actuellement aucun magasin connecté.",
        scopeButton: 'Update Shop',
        updateShopText:
            'Au moins une de tes boutiques doit être mise à jour. <br>Pour cela, clique sur le bouton "Update Shop" et approuve la demande dans Shopify.',
    },
    myDesign: {
        title: 'Mon design',
    },
    myDesignLibrary: {
        title: 'Bibliothèque de design',
        deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce design?',
    },
    myNeckPrintDesignLibrary: {
        title: 'Marquage au col',
        deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce design?',
        lightGarment: 'Tous les vêtements légers',
        darkGarment: 'Tous les vêtements sombre',
        allGarments: 'Léger et sombre vêtement',
        selectBothImages: 'Veuillez sélectionner une image pour les vêtements de couleur claire et de couleur foncée.',
    },
    returns: {
        title: 'Retours management',
        noReturns: 'Il n’y a actuellement aucun retour.',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        store: 'Boutique',
        status: {
            title: 'Statut',
            PENDING: 'En attente',
            PARTIALLY_COMPLETED: 'Partiellement terminé',
            COMPLETED: 'Terminé',
        },
        itemStatus: {
            allStatuses: 'Tous les statuts',
            itemsPendingRefund: 'Remboursement à venir',
            PENDING: 'En attente',
            ACCEPTED: 'Accepté',
            REJECTED: 'Rejeté',
            STORED: 'Stocké',
            SOLD: 'Vendu',
            complaintUnderReview: "Réclamation en cours d'examen",
            complaintRejected: 'Réclamation rejetée',
            complaintAccepted: 'Réclamation acceptée',
        },
        combinedStatus: {
            RETURN_ANNOUNCED: 'Retour annoncé',
            RETURN_STORED: 'Article retourné stocké',
            RETURN_REJECTED: 'Retour rejeté',
            RETURN_SOLD: 'Article retourné vendu',
            COMPLAINT_UNDER_REVIEW: "Réclamation en cours d'examen",
            COMPLAINT_REJECTED: 'Réclamation rejetée',
            COMPLAINT_ACCEPTED: 'Réclamation acceptée',
        },
        search: 'Rechercher',
        reset: 'Réinitialiser les filtres',
        searchPlaceholder: 'Rechercher par commande ou nom du client',
        //tableHeaders:
        orderId: 'ID de commande',
        orderName: 'Commande',
        statusTitle: 'Statut',
        date: 'Date',
        customer: 'Client',
        isDone: 'TerRemboursé au client final ?',
        product: 'Produit',
        noProductTitle: 'Aucun titre de produit',
        subscription: 'Abonnement',
        isReturnManagementActive: 'Retours management',
        frameUrl: 'IFrame URL',
        activate: 'Souscrire',
        deactivate: 'Désabonner',
        copiedToClipboard: 'Copié dans le presse-papier',
    },
    resources: {
        title: 'Ressources',
        blog: 'Blog Print-On-Demand',
        whatsappChannel: 'Chaîne WhatsApp',
        productAndDeliverInformation: 'Informations sur le produit et la livraison',
        productImages: 'Images du produit',
        helpAndFaqs: 'Aide & FAQ',
        bulkOrders: 'Grosse Commande',
        warehousing: 'Entreposage',
    },
    deliveryInformation: 'Info de livraison',
    account: {
        affiliateProgram: "Programme d'affiliation",
        title: 'Compte',
        invoices: 'Factures',
        walletTransactions: 'Transactions du portefeuille',
        settings: 'Paramètres',
        myStores: 'Mes boutiques',
        logout: 'Déconnexion',
        logoutMessage: 'Vous avez été déconnecté en raison de problèmes avec votre compte.',
    },
    sampleOrder: {
        title: 'Créer une commande',
        step1Title: 'Sélectionner la boutique',
        step2Title: 'Sélectionner les produits',
        step3Title: 'Adresse de livraison',
        step4Title: 'Vérifier et soumettre',
        selectStoreSubtitle: 'Choisissez la boutique pour commander l’échantillon',
        submit: 'Passer la commande',
        total: 'Total',
        country: 'Pays *',
        firstName: 'Prénom *',
        lastName: 'Nom *',
        address1: 'Adresse ligne 1 *',
        address2: 'Adresse ligne 2',
        city: 'Ville *',
        zip: 'Code postal *',
        province: 'État',
        phone: 'Téléphone',
        email: 'E-mail',
        reviewStore: 'Boutique sélectionnée',
        reviewProducts: 'Produit sélectionné | Produits sélectionnés',
        invalidCity: 'Le nom de la ville semble trop court.',
        invalidZip: 'Ce code postal ne correspond pas au pays sélectionné.',
        invalidStreet: 'Veuillez indiquer la rue et le numéro.',
        provinceRequired: 'Veuillez sélectionner un État.',
        invalidEmail: 'Veuillez saisir une adresse e-mail valide.',
        countryPlaceholder: 'Choisir un pays',
        countryRestricted: 'Pour la région de produits sélectionnée, seuls ces pays peuvent être livrés.',
        countrySearchPlaceholder: 'Rechercher un pays...',
        countryNoMatch: 'Aucun pays trouvé',
        region: 'Région',
        regionEu: 'Europe & Reste du monde',
        regionUsa: 'USA',
        selectedItems: 'Produits sélectionnés',
        totalQuantity: 'Quantité totale',
        maxItems: 'La quantité totale ne peut pas dépasser 200 articles.',
        loadingProducts: 'Chargement des produits...',
        noProducts: 'Aucun produit trouvé.',
        steps: {
            store: 'Boutique',
            products: 'Produits',
            shipping: 'Livraison',
            review: 'Vérifier',
        },
        noPaymentMethod:
            "Aucun moyen de paiement n'est encore enregistré pour cette boutique. La commande ne sera traitée qu'une fois un moyen de paiement ajouté.",
        addPaymentMethod: 'Ajouter un moyen de paiement',
        submitSuccess: 'Votre commande échantillon {orderId} a été créée !',
        startAnother: 'Créer une autre commande',
        errorZipInvalid: "Le code postal n'est pas valide pour le pays sélectionné. Veuillez vérifier l'adresse de livraison.",
        errorZipStateMismatch: "Le code postal ne correspond pas à l'État sélectionné. Veuillez vérifier l'adresse de livraison.",
        editAddress: "Modifier l'adresse",
        submitError: 'Une erreur est survenue. Veuillez réessayer.',
        priceHeader: 'Montant de la facture',
        priceLoading: 'Calcul du prix...',
        priceError: "Le prix n'a pas pu être calculé. Veuillez vérifier l'adresse de livraison.",
        priceRetry: 'Recalculer',
        shipping: 'Livraison',
        netTotal: 'Sous-total (hors taxes)',
        tax: 'TVA ({rate} %)',
        vipDiscount: 'Remise client VIP',
        free: 'gratuit',
        vatInfo6: "Exportation exonérée de TVA conformément à l'art. 6 UStG.",
        vatInfo6a: "Livraison intracommunautaire exonérée de TVA conformément à l'art. 6a UStG.",
    },
    pagination: {
        prev: 'Précédent',
        next: 'Suivant',
        further: 'Suivant',
        create: 'Créer',
        save: 'Enregistrer',
    },
    search: {
        placeholder: 'Rechercher',
    },
    sort: {
        value: 'Trier',
    },
    filter: {
        label: 'Filtrer',
        searchPlaceholder: 'Rechercher des catégories...',
        clearAll: 'Tout effacer',
        noResults: 'Aucune catégorie trouvée',
    },
    creditCard: {
        error: {
            title: "La carte de crédit n'a pas pu être enregistrée",
            tokenContent: 'Informations de carte de crédit invalides',
            backendContent: "Erreur lors de l'enregistrement des données",
        },
        success: {
            title: 'Enregistré avec succès',
            content: 'Votre carte de crédit a été enregistrée avec succès',
        },
    },
    welcomeBlock: {
        title: `Bienvenue{username}`,
        suggest: 'Explorez notre portfolio de produits et créez votre produit unique en moins de 2 minutes.',
        subtitle:
            "--- Vous trouverez les problèmes connus à jour <a target='_blank' rel='noopener noreferrer' href='https://help.marketprint.de/known-issues/'>ici</a>. ---<br><br>La tant attendue <b>MarketPrint 2.0</b> La mise à jour est enfin en ligne ! Nous avons changé tout le frontend pour vous offrir une meilleure expérience utilisateur.<br><br>S'il y a encore des petits problèmes dans les deux premières semaines, veuillez nous appeler au <b>+49 8261 7939101</b>.<br>Ou laissez votre avis et vos suggestions pour les futures innovations à : <b>feedback@marketconsultive.de</b><br><br>Nous vous souhaitons beaucoup de plaisir avec le nouveau design et sommes impatients de vous entendre ! Nous sommes loin d'avoir terminé et vous remercions pour votre fidélité.<br><br>- Toute l'équipe de <i>MarketConsultive GmbH</i><br><br>PS : Quelques fonctionnalités passionnantes, comme votre propre bibliothèque de designs, seront mises à votre disposition dans les prochaines semaines ! Consultez <a target='_blank' rel='noopener noreferrer' href='https://www.marketprint.de'>www.marketprint.de</a> ! De plus, nous prévoyons un portfolio complet de produits d'au moins 20 nouveaux best-sellers qui seront mis en ligne dans les prochaines semaines et mois.",
        cta: 'Créez un produit maintenant',
    },
    productsIntro: {
        title: 'Notre gamme de produits',
    },
    currentOrders: {
        title: `Commandes en cours:`,
        more: 'Afficher plus...',
    },
    currentOrdersModal: {
        shopifyId: 'ID Shopify',
        trackingNumber: 'Numéro(s) de suivi',
        moreInfo: "Plus d'infos",
        paymentMethod: 'Méthode de paiement',
        transactionNumber: 'Numéro de transaction',
        ordered: 'Commandé',
        inProcess: 'En production',
        shipped: 'Expédié',
        cancelled: 'Annulé',
        refunded: 'Remboursé',
        yes: 'Oui',
        no: 'Non',
        btnUploadDesigns: 'Télécharger les designs',
        btnReleaseForProduction: 'Approuver pour production',
        btnViewOrder: 'Afficher la commande',
        btnUpdateCustomerData: "Mettre à jour l'adresse",
        updateCustomerData: 'Mettre à jour les données du client',
        btnDownloadInvoice: 'Télécharger la facture',
        textReleaseForProduction: 'Voulez-vous vraiment approuver cette commande pour la production?',
        orderReady: 'La commande a été approuvée pour la production!',
        orderReadyErrorTitle: "La commande n'a pas pu être approuvée pour la production!",
        orderReadyError: 'Vérifiez si tous les designs sont complets!',
        btnUploadInvoices: 'Télécharger la facture',
        invoice: 'Facture',
        selectVariant: 'Choisir une variante',
        selectImage: 'Design personnalisé',
        confirmationUpload: 'Téléchargement réussi!',
        notPayed: 'Le paiement à MarketPrint a échoué. Veuillez réessayer dans les paramètres ou contacter notre support.',
        noPreview: "Pas d'aperçu disponible pour les mugs actuellement! \n Vous pouvez toujours télécharger le design.",
        for: 'pour',
        btnRetryPayment: 'Réessayer le paiement',
        uploaded: 'Designs téléchargés',
        downloadInvoice: 'Télécharger la facture',
        noInvoice: 'Facture non disponible',
        noMockups: 'Aucun mockup disponible pour ce produit',
        btnCancel: 'Annuler la commande',
        cancelReason: "Raison de l'annulation",
        textCancel: 'Êtes-vous sûr de vouloir annuler cette commande?',
        orderCancelErrorTitle: "La commande n'a pas pu être annulée",
        orderCancelled: 'La commande a été annulée',
        orderCancelError: 'La commande peut déjà être en production ou expédiée.',
        invoiceUploadErrorTitle: 'Échec du téléchargement de la facture',
        invoiceUploadError: 'Le téléchargement de la facture a échoué. Veuillez réessayer plus tard ou actualiser la page.',
        invoiceUploadSuccess: 'Facture téléchargée avec succès',
        btnAddAddress: 'Ajouter une adresse',
        addAddress: 'Ajouter une adresse de livraison',
        firstName: 'Prénom',
        lastName: 'Nom',
        address1: 'Adresse',
        city: 'Ville',
        zip: 'Code postal',
        countryCode: 'Code pays',
        addressAddedSuccess: 'Adresse ajoutée avec succès',
        addressAddedError: "Échec de l'ajout de l'adresse",
    },
    checklist: {
        title: `Votre liste de contrôle`,
        subtitle: `Il ne reste que quelques étapes pour configurer votre magasin!`,
        installApp: `Installer l'application MarketPrint`,
        createProduct: `Créer un produit`,
        paymentMethod: `Sélectionner un moyen de paiement`,
    },
    todoOrders: {
        title: `Vos tâches à faire`,
        subtitle: `Complétez vos commandes`,
        order: `Téléchargez la facture pour la commande <strong>#{id}</strong>`,
    },
    sortOptions: {
        relevance: 'Pertinence',
        newArrivals: 'Nouveautés',
        bestSelling: 'Meilleures ventes',
        priceLowHigh: 'Prix croissant',
        priceHighLow: 'Prix décroissant',
        ratings: 'Avis',
    },
    home: {
        bestseller: 'Meilleures ventes actuelles de MarketPrint',
        newProducts: 'Nouveaux produits',
        shopConnectSuccess: {
            title: 'Boutique connectée',
            content: 'Votre boutique a été connectée avec succès à MarketPrint.',
        },
        shopConnectError: {
            title: 'Erreur de connexion de boutique',
            content: "Une erreur s'est produite lors de la connexion de votre boutique à MarketPrint. Veuillez réessayer ultérieurement.",
            alreadyConnected:
                "Une erreur s'est produite lors de la connexion de votre boutique à MarketPrint: La boutique est déjà connectée à un autre compte.",
        },
    },
    ordersIntro: {
        orders: 'Aperçu des commandes',
        personalized: 'Commandes personnalisées',
        notEu: 'Commandes hors UE',
    },
    design: {
        editMode: 'Mode édition',
        editingProduct: 'Modification:',
        personalizedEditLocked:
            'Les produits personnalisés ne peuvent pas être modifiés. Seuls le titre, la description et les prix peuvent être changés.',
        variantsAddOnly: 'Les couleurs et tailles existantes ne peuvent pas être supprimées, seules de nouvelles peuvent être ajoutées.',
        selectShop: 'Pour quelle boutique souhaitez-vous créer un produit?',
        selectShopTitle: 'Sélectionner un magasin',
        front: 'Avant',
        back: 'Arrière',
        left: 'Gauche',
        right: 'Droite',
        colors: 'Couleurs',
        size: 'Taille',
        sizes: 'Tailles variées',
        design: 'Conception',
        neckPrint: 'Marquage au col',
        waistband: 'Waistband',
        cuffLeft: 'Cuff gauche',
        cuffRight: 'Cuff droit',
        collar: 'Collar',
        forearmRight: 'Forearm Right',
        forearmLeft: 'Forearm Left',
        useDifferentGarment: 'Utiliser une autre conception',
        showGreenArea: 'Afficher la zone verte',
        titleLibraryNeckPrints: 'Neckprint Library',
        countries: 'Pays',
        germany: 'Allemagne',
        austria: 'Autriche',
        switzerland: 'Suisse',
        landArea: 'Pays / Zone',
        alternativeDesign: 'Conception alternative',
        alternativeDesignColors: 'Conception alternative pour les couleurs suivantes',
        productDescription: 'Description du produit',
        howToDesign: 'Comment concevoir ce produit',
        downloadProductData: 'Télécharger la fiche produit et les maquettes',
        designNote: 'Notes de création de conception',
        sizeChart: 'Tableau des tailles',
        insertGraphic: 'Insérer un graphique',
        moveLayerUp: 'Déplacer le calque vers le haut',
        moveLayerDown: 'Déplacer le calque vers le bas',
        important: `<span>Important:</span> Placez votre conception à l'intérieur du marqueur extérieur vert. Si vous dépassez les lignes, votre conception ne sera pas complètement imprimée sur le produit.`,
        productTitle: 'Titres du produit',
        productTitlePlaceholder: 'Ajouter un titre',
        productDescriptionPlaceholder: 'Ajouter une description',
        doubleSidedPrint: 'Impression multi-faces - déjà incluse',
        additionalNeckPrice: 'Impression de la jupe - déjà incluse',
        purchasePriceVat: "Prix d'achat (hors TVA)",
        purchasePrice19Vat: "Prix d'achat (TVA incluse 19%)",
        sellingPrice19VAt: 'Prix de vente (TVA incluse 19%)',
        sellingPrice: 'Prix de vente',
        profitMargin: 'Votre marge bénéficiaire (brute)',
        profitMarginWithVat: 'Votre marge bénéficiaire',
        price: 'Prix',
        shippingCostsOverview: 'Aperçu des frais de port',
        shippingPrice: 'Prix de livraison',
        shippingPricesAreNet: 'Tous les prix sont nets.',
        shippingProduct: 'Produit',
        usaShippingStandard: 'T-shirts et autres produits',
        usaShippingHeavy: 'Sweats à capuche, sweats, zippers, pantalons de jogging',
        additionalPricePerProduct: 'Un supplément de 0,84 € sera facturé par produit supplémentaire dans la commande',
        additionalItems: 'Articles supplémentaires',
        addSizeChart: 'Ajouter un tableau des tailles à la boutique',
        publishProduct: 'Publier le produit sur Shopify',
        collections: 'Collections',
        collectionsLoading: 'Chargement des collections...',
        noCollections: 'Aucune collection disponible',
        collectionsSearch: 'Rechercher des collections...',
        collectionsNoResults: 'Aucune collection correspondante',
        collectionsSelected: '{count} sélectionné(s)',
        catalogs: 'Catalogues',
        catalogsLoading: 'Chargement des catalogues...',
        noCatalogs: 'Aucun catalogue disponible',
        catalogsSearch: 'Rechercher des catalogues...',
        catalogsNoResults: 'Aucun catalogue correspondant',
        catalogsSelected: '{count} sélectionné(s)',
        shippingProfiles: "Profil d'expédition",
        shippingProfilesLoading: "Chargement des profils d'expédition...",
        noShippingProfiles: "Aucun profil d'expédition disponible",
        shippingProfilesSearch: "Rechercher des profils d'expédition...",
        shippingProfilesNoResults: "Aucun profil d'expédition correspondant",
        shippingProfileDefault: 'Expédition par défaut MarketPrint',
        shopSelectionTitle: 'Sélectionner la boutique',
        shopSelectionSubtitle: 'Choisissez la boutique à laquelle ajouter votre produit',
        chooseMockup: 'Choisissez votre maquette',
        titleLibrary: 'Votre bibliothèque de conceptions',
        addDesignLibrary: `Télécharger une nouvelle conception`,
        personalProduct: 'Ceci est un produit personnalisable',
        tibProductFront: "Optimiser l'avant",
        tibProductBack: "Optimiser l'arrière",
        tibProductSleeveLeft: 'Optimiser la manche gauche',
        tibProductSleeveRight: 'Optimiser la manche droite',
        tibProductLeft: 'Optimiser la gauche',
        tibProductRight: 'Optimiser la droite',
        tibProductFrontLeft: "Optimiser l'avant gauche",
        tibProductFrontRight: "Optimiser l'avant droit",
        tibProductBackLeft: "Optimiser l'arrière gauche",
        tibProductBackRight: "Optimiser l'arrière droit",
        tibProductSideLeft: 'Optimiser côté gauche',
        tibProductSideRight: 'Optimiser côté droit',
        tibProductTop: 'Optimiser le haut',
        tibProductChestLeft: 'Optimiser le sein gauche',
        tibProductChestRight: 'Optimiser le sein droit',
        tibProductForearmLeft: 'Optimiser le bras gauche',
        tibProductForearmRight: 'Optimiser le bras droit',
        tibProductCuffLeft: 'Optimiser le poignet gauche',
        tibProductCuffRight: 'Optimiser le poignet droit',
        tibProductWaistband: 'Optimiser la bande de taille',
        tibProductCollar: 'Optimiser le col',
        tibProductAll: 'Tout optimiser',
        quality: {
            good: 'Bon',
            normal: 'Moyen',
            bad: 'Mauvais',
        },
        productCreated: 'Produit créé',
        productCreateError: "Le produit n'a pas pu être créé",
        productUpdated: 'Produit mis à jour avec succès',
        productUpdateError: "Le produit n'a pas pu être mis à jour",
        maxOne: "Un maximum d'un graphique",
        infoCanvas: `<span>Placement:</span> Côté avant de la toile à l'intérieur du cadre gris foncé,
            côté
            Chevauchement jusqu'à la ligne verte.`,
        infoPoster: `<span>Placement:</span> Placement des
            conceptions jusqu'à la ligne verte extérieure. La zone grise
            est coupée pendant la production.`,
        infoGlas: `<span>Pas de placement:</span> Pour les travaux de gravure, nous ne fournissons <b>aucun</b> placement pour
            disponible, veuillez modifier vos graphiques vectoriels en conséquence puis charger l'image
            à nouveau pour ajuster le placement.<br><br>
            <span>Rapport d'aspect fixe:</span> Assurez-vous que votre SVG a la <b>largeur
            {printMediumWidth} </b> et la <b>hauteur {printMediumHeight}</b> .<br>
            Alternativement, définissez la largeur et la hauteur de manière à ce qu'elles aient le même rapport d'aspect que <b> {printMediumAspectRatio} </b>.<br><br>
            <span>Un seul fichier de conception:</span> Il ne peut y avoir <b>qu'un seul</b> graphique vectoriel pour la conception
            être utilisé.`,
        disabledStep2: `Pour passer à l'étape suivante, vous devez choisir: Couleur, Taille et Télécharger l'image`,
        disabledStep3: `Pour passer à l'étape suivante, vous devez spécifier le nom du produit, la description et le prix`,
        uploadErrorMessageBeer:
            "Le rapport d'aspect SVG ne correspond pas au rapport d'aspect du support d'impression (largeur/hauteur = 1,67). Veuillez réessayer avec un fichier correspondant !",
        uploadErrorMessageWine:
            "Le rapport d'aspect SVG ne correspond pas au rapport d'aspect du support d'impression (largeur/hauteur = 1). Veuillez réessayer avec un fichier correspondant !",
        uploadErrorPngOnly: 'Veuillez utiliser une image .png pour ce produit',
        uploadErrorTitle: 'Erreur de téléchargement',
        sleeveRight: 'Manche droite',
        sleeveLeft: 'Manche gauche',
        frontLeft: 'Avant gauche',
        frontRight: 'Avant droit',
        backLeft: 'Arrière gauche',
        backRight: 'Arrière droit',
        sideLeft: 'Côté Gauche',
        sideRight: 'Côté Droit',
        top: 'Haut',
        chestLeft: 'Côte gauche',
        chestRight: 'Côte droit',
        combinedDesignTitle: 'Même conception sur tous les côtés',
        combinedDesignDescription: 'Désactivez cette option si vous souhaitez avoir des conceptions différentes sur la pantoufle gauche et droite',
        designDownload: 'Téléchargement de la conception',
        addToShop: 'Ajouter au magasin',
        sizeChartTooltip: 'Le tableau des tailles est un tableau qui montre à vos clients les mesures du produit.',
        supportedPrinterTypes: "Type d'imprimante:",
        printerType: {
            dtf: 'DTF',
            dtg: 'DTG',
            sublimation: 'Sublimation',
            laser: 'Laser',
            aop: 'AOP',
        },
        dtfModal: {
            headline: 'DTF Information',
            info: "Pour que tes designs soient mis en œuvre de manière optimale dans l'impression DTF, veuillez tenir compte des indications suivantes :",
            points: [
                "Pas d'éléments de design semi-transparents : les éléments transparents ou à opacité réduite ne peuvent pas être représentés proprement dans l'impression DTF. Utilise plutôt des couleurs opaques ou simule la transparence avec des motifs en demi-teinte (par exemple des points ou des trames).",
            ],
            dontShowAgain: "Ne pas réafficher l'avertissement",
            priceInformation:
                "Pour la technologie d'impression DTF, un prix de 0,50€ (HT) par article et zone d'impression supplémentaire est ajouté.",
            headlineWarning: 'Avertissement DTF',
            transparencyWarning: 'Cette image contient des pixels transparents et pourrait avoir un aspect inattendu.',
            transparencyWarningUseDTG: "Nous vous recommandons d'imprimer votre conception avec DTG.",
            continueDtf: 'Continuer avec DTF',
            continueDtg: 'Choisir DTG (recommandé)',
        },
        updateShopInfo: 'Ta boutique doit être mise à jour pour pouvoir télécharger le produit. <br>Tu peux le faire <a href="/my-stores">ici</a>.',
        transparencyWarning: 'Cette image contient des pixels transparents et pourrait paraître inattendue.',
        aiKeywordsLabel: 'Mots-clés',
        aiKeywordsPlaceholder: 'ex. coton biologique, doux, premium, durable',
        aiToneLabel: 'Ton',
        aiToneProfessional: 'Professionnel',
        aiToneCasual: 'Décontracté',
        aiToneFriendly: 'Amical',
        aiToneDaring: 'Audacieux',
        aiInstructionsLabel: 'Instructions spéciales',
        aiInstructionsPlaceholder: 'Indications optionnelles (longueur, points à mettre en avant, etc.)',
        aiGenerateButton: 'Générer avec IA',
        aiGenerateAgainButton: 'Générer',
        aiKeepButton: 'Conserver',
        aiPreviewLabel: 'Aperçu',
        aiGenerateReplaces: 'Remplace la description actuelle',
        aiGenerateError: "La description n'a pas pu être générée. Veuillez réessayer.",
        salesRegion: 'Région de vente',
        noRegionSelected: 'Aucune région sélectionnée',
        quickActions: {
            changeProduct: 'Changer de produit',
            addDesign: 'Ajouter un design',
            changeProductTitle: 'Changer de produit',
            currentProduct: 'Actuel',
        },
        createMultipleProducts: 'Créer plusieurs produits',
    },
    multiDesigner: {
        title: 'Designer multi-produits',
        subtitle: 'Concevoir et créer plusieurs produits en même temps',
        loading: 'Chargement...',
        loadingMockups: 'Génération des maquettes...',
        backToProducts: 'Retour aux produits',
        backToDesign: 'Retour au design',
        backToDesigner: 'Retour au concepteur',
        addProduct: 'Ajouter un autre produit',
        selectProduct: 'Sélectionner un produit',
        searchProducts: 'Rechercher',
        searchPlaceholder: 'Rechercher par nom ou type...',
        noProductsFound: 'Aucun produit trouvé',
        maxReached: 'Maximum de {max} produits atteint',
        products: 'produits',
        variants: 'variantes',
        ready: 'Prêt',
        incomplete: 'Incomplet',
        closeDesigner: 'Supprimer le produit',
        completeAllDesigners: 'Veuillez compléter tous les designs de produits avant de continuer',
        completeAllProducts: 'Veuillez compléter tous les détails des produits avant de créer',
        confirmTitle: 'Confirmer vos produits',
        confirmSubtitle: 'Vérifiez et finalisez les détails de vos produits',
        shopSelectionTitle: 'Sélectionner les boutiques',
        shopSelectionSubtitle: 'Choisissez les boutiques auxquelles ajouter tous les produits',
        selectAtLeastOneShop: 'Veuillez sélectionner au moins une boutique',
        createAllProducts: 'Créer tous les produits',
        successTitle: 'Produits créés',
        successMessage: 'Vos produits ont été créés avec succès !',
        productsCreated: 'produits créés',
        productsFailed: 'produits échoués',
        viewProducts: 'Voir mes produits',
    },
    publishProduct: {
        title: 'Ajouter au magasin',
    },
    aiAccess: {
        title: "Autoriser l'accès IA",
        request: '{client} demande à agir sur votre compte MarketPrint.',
        scopeCatalogue: 'Parcourir les produits que vous pouvez imprimer',
        scopeUpload: 'Importer des designs dans votre compte',
        scopeCreate: 'Créer et publier des produits sur vos boutiques connectées',
        ownAccountOnly: "L'accès ne concerne que votre propre compte et peut être révoqué à tout moment dans les paramètres.",
        allow: 'Autoriser',
        deny: 'Refuser',
        unknownClient: 'Un assistant IA',
        missingInteraction: "Ce lien d'autorisation est invalide ou expiré. Veuillez recommencer depuis votre assistant IA.",
        sessionExpired: 'Votre session a expiré. Veuillez recharger la page et vous reconnecter.',
        failed: "Impossible de terminer l'autorisation. Veuillez réessayer.",
    },
    accountSettings: {
        title: 'Paramètres',
        shopSettings: 'Paramètres de la boutique',
        noShops: 'Aucun magasin ajouté pour le moment.',
        subtitle: 'Gérez les paramètres de votre profil.',
        contactInfo: 'Coordonnées',
        paymentInfo: 'Informations de paiement',
        email: 'E-Mail',
        tel: 'Téléphone',
        billingAddress: 'Adresse de facturation',
        billingAddressTooltip: "Ceci est l'adresse qui apparaîtra sur les factures.",
        senderAddress: "Adresse de l'expéditeur",
        senderAddressTooltip:
            "Ceci est l'adresse qui apparaît comme expéditeur sur les étiquettes d'expédition. Seules les adresses en Allemagne sont autorisées.",
        senderAddressEU: "Adresse de l'expéditeur (EU)",
        senderAddressUSA: "Adresse de l'expéditeur (USA)",
        senderAddressUSATooltip:
            "Ceci est l'adresse qui apparaît comme expéditeur sur les étiquettes d'expédition. Seules les adresses aux États-Unis sont autorisées.",
        paymentServiceProvider: 'Service de paiement',
        paymentServiceProviderEU: 'Service de paiement (EU)',
        paymentServiceProviderUS: 'Service de paiement (US)',
        billingAgreement: 'Accord de facturation',
        deposited: 'Déposé',
        changePaymentMethod: 'Changer le mode de paiement',
        tryAgain: 'Réessayer',
        addPayment: 'Ajouter',
        changePayment: 'Modifier',
        deletePayment: 'Supprimer',
        deletePaymentTitle: 'Supprimer le moyen de paiement',
        deletePaymentConfirm: 'Voulez-vous vraiment supprimer ce moyen de paiement ?',
        deletePaymentDone: 'Moyen de paiement supprimé',
        retryPayment: 'Relancer le paiement échoué',
        retryPaymentSuccess: 'Relance du paiement déclenchée',
        retryPaymentError: 'Échec de la relance du paiement',
        notifications: 'Notification',
        preferredLanguage: 'Langue préférée',
        preferredLanguageDescription:
            "Lorsque vous êtes connecté à MarketPrint, c'est la langue que vous voyez.<br/>Vous pouvez changer la langue à tout moment.",
        productLanguage: 'Ajouter des produits dans la boutique',
        productLanguageDescription:
            "Ici, vous pouvez changer la langue de votre produit et l'unité de mesure du tableau des tailles lors de l'importation dans votre boutique.",
        preferredPrinterTypeTeeInBlue: "Type d'imprimante préféré pour les commandes via TeeInBlue:",
        apiToken: 'Jeton API',
        apiTokenDescription:
            "Ici, vous pouvez générer un jeton API à utiliser avec différents services. Après avoir généré votre jeton, vous ne pouvez le voir qu'une seule fois. Veuillez le sauvegarder dans un endroit sûr. Vous pouvez toujours générer un nouveau jeton, ce qui invalidera l'ancien.",
        generate: 'Générer',
        regenerate: 'Régénérer',
        popup: 'Veuillez autoriser la fenêtre pop-up pour stocker vos données de paiement',
        notificationsCheckbox: {
            failedPayment: "Recevoir une notification en cas d'échec de paiement",
            personalizedDesign: "Recevoir une notification lorsqu'un design personnalisé doit être téléchargé",
            tips: 'Souhaitez-vous recevoir des conseils et des informations de MarketPrint par E-Mail?',
        },
        editBillingAddress: "Modifier l'adresse de facturation",
        address: {
            title: 'Adresse',
            firstName: 'Prénom',
            lastName: 'Nom',
            address1: 'Adresse 1',
            address2: 'Adresse 2',
            company: 'Entreprise',
            phone: 'Téléphone',
            email: 'E-Mail',
            name: 'Nom / Entreprise',
            nameAddition: 'Complément (2e ligne)',
            address1Street: 'Rue',
            address1Number: 'Numéro de maison',
            city: 'Ville',
            zip: 'Code postal',
            countryCode: 'Code pays',
            countryName: 'Pays',
            province: 'État',
            validate: {
                zipWarning: {
                    title: 'Code postal invalide!',
                    content: "Ce code postal n'est pas valide. Veuillez vérifier votre saisie.",
                },
            },
            noChanges: 'Veuillez apporter des modifications avant de sauvegarder',
            phoneOrEmailRequired: 'Numéro de téléphone ou e-mail est requis',
            vatId: 'ID TVA',
            chooseExisting: '--- Choisissez une adresse existante ---',
        },
        language: 'Langue:',
        units: 'Unités:',
        shoeSizes: 'Tailles de chaussures:',
        editSenderAddressToasts: {
            success: "Adresse de l'expéditeur enregistrée avec succès",
        },
        editInvoiceAddressToasts: {
            success: {
                content: 'Votre adresse de facturation a été enregistrée avec succès.',
            },
            unavailable: {
                title: 'Avertissement',
                content:
                    "Nous n'avons pas pu vérifier votre numéro de TVA pour le moment, mais votre adresse a été enregistrée. Veuillez réessayer plus tard.",
            },
            invalid: {
                content: "Le numéro de TVA fourni n'est pas enregistré.",
            },
            format: {
                content: "Le numéro de TVA fourni n'a pas le bon format. Veuillez vérifier votre saisie.",
            },
        },
        save: 'Enregistrer',
        editSenderAddress: "Modifier l'adresse de l'expéditeur",
        editSenderAddressEU: "Modifier l'adresse de l'expéditeur (EU)",
        editSenderAddressUSA: "Modifier l'adresse de l'expéditeur (USA)",
        general: "Changer d'adresse",
        selectPayment: 'Veuillez choisir',
        paypal: 'PayPal',
        creditCard: 'Carte de crédit',
        notDeposited: 'Non déposé',
        deposit: 'Faire un dépôt',
        paymentError: 'Mode de paiement non disponible',
        tib: 'TeeInBlue',
        connectTibProductInfo: 'Connectez votre produit TiB à MarketPrint',
        saveIntegrationApiInfosInfo: "Enregistrez vos informations API TiB pour pouvoir recevoir des mises à jour d'expédition dans TeeInBlue",
        webhookUrl: 'URL du Webhook',
        stockAvailabilityTitle: 'Disponibilité des stocks',
        stockAvailabilityCheckbox: 'Mettre à jour automatiquement la disponibilité des stocks',
        stockAvailabilityDescription:
            "Si cette option est cochée, vos produits sont automatiquement marqués comme épuisés dès qu'ils ne sont plus disponibles chez nos fournisseurs ou que le produit a été abandonné par le fabricant. <br> <br>Si non cochée, les produits seront toujours affichés comme disponibles même si le produit est abandonné ou en rupture de stock chez nos fournisseurs.",
        updateEmail: {
            title: "Mettre à jour l'adresse e-mail",
            placeholder: 'Nouvelle adresse e-mail',
            confirm: "Confirmer l'adresse e-mail",
            email: 'Adresse e-mail',
            button: "Mettre à jour l'adresse e-mail",
            success: {
                title: 'Succès',
                message: 'Veuillez suivre les instructions envoyées à votre adresse e-mail pour vérifier votre nouvelle adresse e-mail.',
            },
            error: {
                title: "Erreur de mise à jour de l'adresse e-mail",
                emailExists: "L'adresse e-mail donnée est déjà enregistrée.",
                rateLimit: 'Trop de tentatives. Veuillez patienter et réessayer.',
                unknown: "Une erreur inconnue s'est produite. Veuillez réessayer ultérieurement.",
            },
        },
        addShop: {
            title: 'Ajouter un magasin',
            reconnectTitle: 'Le magasin doit être reconnecté',
            howToLogin: 'Où puis-je trouver mon URL ?',
            add: 'Ajouter',
            connectShop: 'connecter',
            connectShopInfo: {
                etsy: 'Etsy est un marché en ligne où les petits commerçants peuvent vendre des produits fabriqués par eux-mêmes de divers domaines tels que bijoux, art et mode.',
            },
        },
        disconnectShop: {
            title: 'Déconnecter la boutique',
            description:
                'Cela marquera la boutique comme déconnectée. Tout continuera de fonctionner comme avant, mais il sera alors possible de connecter la boutique à un autre compte. Si la boutique est connectée à un autre compte, tous les produits et designs pertinents pour cette boutique seront dupliqués dans le nouveau compte.',
            disconnect: 'Déconnecter la boutique',
            reconnect: 'Reconnecter la boutique',
            statusConnected: 'Statut : <b style="color: var(--color-secondary)">Connecté</b>',
            statusDisconnected: 'Statut : <b style="color: var(--color-primary)">Déconnecté</b>',
        },
        mcpTokens: {
            title: 'Accès assistant IA',
            description:
                "Créez un jeton d'accès pour permettre à un assistant IA de parcourir votre catalogue, d'importer des designs et de créer des produits sur vos boutiques connectées en votre nom. Traitez un jeton comme un mot de passe - toute personne le détenant peut agir sur votre compte. Vous pouvez le révoquer à tout moment.",
            label: 'Nom',
            labelPlaceholder: 'ex. mon assistant IA',
            created: 'Créé le',
            lastUsed: 'Dernière utilisation',
            status: 'Statut',
            never: 'Jamais',
            statusActive: 'Actif',
            statusRevoked: 'Révoqué',
            statusExpired: 'Expiré',
            create: 'Créer un jeton',
            expiryNever: "N'expire jamais",
            expiryDays: 'Expire dans {days} jours',
            noTokens: "Aucun jeton d'accès pour le moment.",
            mintedTitle: "Votre nouveau jeton d'accès",
            mintedWarning: 'Copiez-le maintenant - pour votre sécurité, il ne sera plus affiché. Si vous le perdez, créez-en un nouveau.',
            copy: 'Copier',
            copied: 'Copié',
            copyFailed: 'Impossible de copier dans le presse-papiers. Veuillez sélectionner le jeton et le copier manuellement.',
            dismiss: 'Terminé',
            revoke: 'Révoquer',
            revokeTitle: "Révoquer le jeton d'accès",
            revokeConfirm: "Révoquer « {label} » ? Tout ce qui utilise ce jeton perdra immédiatement l'accès. Cette action est irréversible.",
            revoked: "Jeton d'accès révoqué.",
            revokeFailed: 'Impossible de révoquer le jeton. Veuillez réessayer.',
            mintFailed: 'Impossible de créer le jeton. Veuillez réessayer.',
        },
    },
    shopSelector: {
        noShops: 'Aucun magasin disponible',
        noShopSelected: 'Aucun magasin sélectionné',
        allShopsSelected: 'Tous les magasins sélectionnés',
        notConnected: '(non installé)',
        notOnboarded: '(non onboardé)',
        disconnected: '(déconnecté)',
        all: 'Tous les magasins',
    },
    myProducts: {
        title: 'Mes produits',
        editProducts: {
            title: 'Modifier le produit',
            productTitle: 'Titre du produit',
            shopDomain: 'Boutique',
            productTitlePlaceholder: 'Titre du produit',
            supportedPrinterTypes: "Type d'imprimante:",
            productInfo: 'Informations sur le produit',
            syncsToAllShops: 'se synchronise avec toutes les boutiques',
            productDescription: 'Description:',
            productDescriptionPlaceholder: 'Entrez la description du produit...',
            metadataSyncInfo: 'Les modifications seront synchronisées avec toutes les boutiques où ce produit est publié.',
            shopSettings: 'Paramètres de la boutique',
            perShop: 'par boutique',
            syncingToShops: 'Synchronisation avec',
            shops: 'boutiques',
            editDesign: 'Modifier le design',
            editDesignDescription: 'Pour modifier le titre, la description, les variantes ou le design, utilisez le designer.',
            editDesignHint: "Modifier les fichiers d'impression et le placement du design",
            variantPrices: 'Prix des variantes',
            variantSyncInfo: 'Les modifications de prix seront synchronisées avec toutes les boutiques où ce produit est publié.',
            variantManagement: 'Gestion des variantes',
            addVariants: 'Ajouter des variantes',
            removeVariant: 'Supprimer la variante',
            toBeRemoved: 'À supprimer',
            newVariant: 'Nouveau',
        },
        editAllProducts: 'Modifier tous les produits',
        editAllProductsWarning:
            "Cela change le type d'imprimante pour tous les produits de la boutique sélectionnée. Cette action ne peut pas être annulée.",
        editAllProductsError: "Une erreur s'est produite lors de l'enregistrement des modifications",
        editAllProductsSuccess: "Le type d'imprimante pour tous les produits de la boutique sélectionnée a été changé avec succès",
        editProductsError: "Une erreur s'est produite lors de l'enregistrement des modifications",
        editProductsSuccess: "Le type d'imprimante pour le produit a été changé avec succès",
        multiExport: {
            button: 'Créer un produit multiple',
            title: 'Créer un produit multiple',
            steps: {
                products: 'Sélectionner des produits',
                details: 'Titre et prix',
            },
            selectStoreTitle: 'Sélectionner la boutique',
            selectStoreSubtitle: 'Choisissez la boutique dont les produits seront combinés',
            step1Title: 'Sélectionner des produits',
            step2Title: 'Définir le titre, la description et les prix',
            noEligibleProducts: 'Aucun produit éligible trouvé pour cette boutique',
            searchPlaceholder: 'Rechercher des produits...',
            noSearchResults: 'Aucun produit ne correspond à votre recherche',
            variants: 'variantes',
            selectedProducts: 'Produits sélectionnés',
            detailsHeader: 'Détails du produit',
            pricesHeader: 'Prix des variantes',
            previewTitle: 'Aperçu',
            productLabel: 'Produit {number} - {title}',
            skuWarning:
                "Ne modifiez pas les UGS de ces variantes dans Shopify après l'export - cela empêcherait le traitement de la commande pour cette variante.",
            submit: 'Créer le produit',
            createNew: 'Créer un nouveau produit multiple',
            success: 'Produit créé avec succès :',
            partialFailure: 'Le produit a été créé, mais certaines variantes ont échoué :',
            error: 'Échec de la création du produit combiné. Veuillez réessayer.',
            productLoadFailed: 'Impossible de charger ce produit. Veuillez réessayer.',
        },
    },
    noResults: {
        text: "Il n'y a pas encore de commandes disponibles",
        products: "Il n'y a pas encore de produits disponibles dans cette catégorie",
    },
    noShops: {
        connected: "Il n'y a actuellement aucun magasin connecté. Pour connecter un magasin, allez sur la",
        settings: 'paramètres',
    },
    shared: {
        yes: "D'accord",
    },
    invoices: {
        title: 'Factures',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        shop: 'magasin',
        download: 'Télécharger le PDF',
        downloadCSV: 'Télécharger le CSV',
        annotation:
            'Le téléchargement des fichiers PDF peut prendre un certain temps. Veuillez noter que le nombre maximum de factures est de 5000. Les temps de téléchargement varient, mais il faut généralement environ 5 minutes pour télécharger 1000 factures.',
        noResults: "Il n'y a pas de factures pour cette période.",
        countFound: 'Factures trouvées dans la période sélectionnée : {count}',
        countWarning:
            'Avertissement : Le nombre de factures dans la période sélectionnée dépasse la limite de {limit} factures. Veuillez ajuster la période.',
        downloadDisabled:
            'Les téléchargements sont désactivés car le nombre de factures dépasse la limite de {limit} factures. Veuillez ajuster la période pour continuer.',
    },
    login: {
        install1: `Se connecter<br>à `,
        install2: ' ',
        shopUrl: 'Entrez un domaine Shopify (NOMDEBOUTIQUE.myshopify.com):',
        redirect: 'Redirigé...',
        login: 'Connexion',
        marketprint: 'MarketPrint',
        company: 'MarketPrint - MarketConsultive GmbH',
        companyAddress: 'Allgäuerstraße 20, 87719 Mindelheim, Allemagne',
        password: 'Mot de passe',
        registerInstead: "S'inscrire",
        error: {
            title: 'Erreur de connexion',
            rateLimit: 'Trop de tentatives de connexion. Veuillez patienter un instant et réessayer.',
            emailNotConfirmed: "Cette adresse e-mail n'a pas encore été confirmée.",
            invalidCredentials: 'Identifiants invalides.',
            firstTimeApiCallFailed: 'Votre compte a été créé mais il y a eu une erreur interne. Veuillez vous connecter ou vous inscrire à nouveau.',
            unknown: "Une erreur inconnue s'est produite. Veuillez réessayer ultérieurement.",
        },
    },
    emailResend: {
        title: "Renvoyer l'e-mail de confirmation",
        success: {
            title: 'Succès',
            message: "L'e-mail de confirmation a été renvoyé.",
        },
        error: {
            title: 'Erreur de renvoi',
            rateLimit: 'Trop de tentatives. Veuillez attendre un moment et réessayer.',
            unknown: "Une erreur inconnue s'est produite. Veuillez réessayer plus tard.",
        },
    },
    forgotPassword: {
        forgotPassword: 'Mot de passe oublié ?',
        enterEmail: 'Veuillez entrer votre adresse e-mail pour recevoir un lien de réinitialisation de mot de passe.',
        resetPassword: 'Réinitialiser le mot de passe',
        success: {
            title: 'Succès',
            message: 'Un e-mail a été envoyé à votre adresse e-mail avec un lien de réinitialisation de mot de passe.',
        },
        error: {
            title: 'Erreur de réinitialisation du mot de passe',
            unknown: "Une erreur inconnue s'est produite. Veuillez réessayer ultérieurement.",
        },
    },
    updatePassword: {
        success: {
            title: 'Succès',
            message: 'Votre mot de passe a été mis à jour avec succès.',
        },
        error: {
            title: 'Erreur de mise à jour du mot de passe',
            samePassword: "Le mot de passe doit être différent de l'ancien mot de passe.",
        },
        confirm: 'Confirmation du mot de passe',
        button: 'Mettre à jour le mot de passe',
        placeholder: 'Nouveau mot de passe',
        title: 'Mettre à jour le mot de passe',
        nonceMessage: 'Un code a été envoyé à votre adresse e-mail. Veuillez saisir le code ci-dessous pour continuer.',
        noncePlaceholder: 'Code à usage unique',
        nonceInvalid: 'Le code fourni est invalide.',
    },
    register: {
        register: "S'inscrire",
        loginInstead: 'Se connecter',
        error: {
            title: 'Erreur de registre',
            rateLimit: 'Trop de tentatives de registre. Veuillez patienter un instant et réessayer.',
            emailExists: 'Cette adresse e-mail est déjà enregistrée.',
            weakPassword:
                'Le mot de passe saisi est trop faible. Le mot de passe doit comporter au moins 8 caractères et contenir une lettre majuscule/minuscule, un chiffre et un caractère spécial.',
            unknown: "Une erreur inconnue s'est produite. Veuillez réessayer ultérieurement.",
        },
        success: {
            title: 'Inscription réussie',
            message: 'Votre inscription a été enregistrée avec succès. Veuillez vérifier vos e-mails pour confirmer votre compte.',
        },
    },
    onboarding: {
        title: 'Bienvenue chez MarketPrint !',
        welcomeText: `Merci d'utiliser notre service d'impression à la demande !<br><br>
            Nous sommes une entreprise moderne et passionnée qui offre un service d'impression à la demande tout-en-un et fait tout pour offrir aux commerçants en ligne Shopify la meilleure et la plus facile expérience utilisateur dans le commerce en ligne.<br>
            Nous travaillons en permanence sur notre application et notre service pour rendre le modèle commercial de l'impression à la demande accessible à tous et vous offrir la possibilité d'accéder à un portefeuille de produits en constante expansion et à un processus de commande automatisé.<br><br>
            Nous sommes toujours ouverts aux suggestions d'amélioration concernant notre application Shopify. N'hésitez pas à nous appeler pour cela ou à écrire à notre support.<br><br>
            Amusez-vous avec l'application MarketPrint et faites de bonnes ventes,<br>
            L'équipe MarketPrint`,
        privacy:
            "J'ai lu les <a href='https://marketprint.de/agb/' target='blank'>Conditions Générales</a> et la <a href='https://marketprint.de/datenschutzerklarung-marketprint-app/' target='_blank'>Politique de Confidentialité</a> et je les accepte",
        emailNotifications: 'Je souhaite être informé par MarketPrint des nouveaux produits et des actualités par e-mail',
        formTitle: 'Très important pour un démarrage parfait :',
        formText: `Pour que vos commandes entrantes soient traitées automatiquement, vous devez entrer votre méthode de paiement. Nous proposons PayPal ou carte de crédit comme option et recommandons de déposer votre méthode de paiement et votre adresse de facturation dès maintenant pour un démarrage sans encombre.<br><br>
            Veuillez remplir le formulaire et choisir la méthode de paiement qui vous convient :`,
        billingAddress: "Ajouter l'adresse de facturation :",
        name: 'Nom :',
        namePlaceholder: 'Entrez votre nom',
        firstName: 'Prénom :',
        firstNamePlaceholder: 'Entrez le prénom',
        company: 'Entreprise (facultatif) :',
        companyPlaceholder: "Indiquer l'entreprise",
        addressStreet: 'Rue:',
        addressStreetPlaceholder: 'Ajouter la rue',
        addressNumber: 'Numéro de maison:',
        addressNumberPlaceholder: 'Ajouter le numéro de maison',
        postcode: 'Code postal :',
        postcodePlaceholder: 'Ajouter code postal',
        country: 'Pays :',
        countryPlaceholder: 'Sélectionner un pays',
        paymentMethod: 'Sélectionner un prestataire de services de paiement :',
        thankYouTitle: "Vous l'avez fait ! 🎉",
        thankYouText: `Vous avez tout fait et êtes prêt à créer et lancer votre propre marque.<br>
            Créons ensemble votre tout premier produit. Vous verrez à quel point c'est facile et rapide.<br><br>
            Essayez-le dès maintenant, cliquez simplement sur le bouton et créons votre premier produit directement avec l'un de nos best-sellers.`,
        thankYouNext: 'Commencez maintenant !',
        thankYouBack: 'Passer',
        city: 'Ville :',
        cityPlaceholder: 'Ajouter ville',
        error: {
            title: "Les informations du compte n'ont pas pu être enregistrées",
            backendContent: "Erreurs lors de l'enregistrement des données",
        },
        regionLabel: 'Où vendez-vous principalement ?',
        sourceLabel: 'Comment avez-vous entendu parler de nous ?',
        sourceSelect: 'Veuillez sélectionner...',
        sourceOtherLabel: 'Autre (veuillez préciser)',
        sourceOtherPlaceholder: 'Veuillez préciser...',
        sourceFriends: 'Amis & Connaissances',
        sourceOther: 'Autre',
        sourceAppStore: 'App Store',
        sourceGoogle: 'Recherche Google',
        sourceSocial: 'Réseaux sociaux',
        tiktokResponsiblePerson: {
            title: 'Personne responsable (conformité UE)',
            hint: 'TikTok exige que les boutiques UE enregistrent une personne responsable de la conformité des produits. Cette personne est responsable devant les autorités du respect de la réglementation UE. Veuillez remplir tous les champs — ces informations sont envoyées directement à TikTok et sont obligatoires pour exporter des produits.',
            name: 'Nom / Raison sociale :',
            namePlaceholder: 'Jean Dupont ou Exemple SARL',
            email: 'E-mail :',
            emailPlaceholder: 'responsable@exemple.fr',
            phoneCountryCode: 'Indicatif pays :',
            phoneCountryCodePlaceholder: '+33',
            phoneLocalNumber: 'Numéro de téléphone :',
            phoneLocalNumberPlaceholder: '612345678',
            street: 'Rue & numéro :',
            streetPlaceholder: '1 Rue Exemple',
            postalCode: 'Code postal :',
            postalCodePlaceholder: '75001',
            country: 'Pays :',
            error: "Les données n'ont pas pu être transmises à TikTok. Veuillez vérifier vos informations.",
        },
    },
    success: {
        title: 'Succès',
    },
    error: {
        title: 'Erreur',
        content: "Une erreur s'est produite",
    },
    header: {
        notifications: 'Notifications',
    },
    countries: {
        Deutschland: 'Allemagne',
        Österreich: 'Autriche',
        Schweiz: 'Suisse',
        Andorra: 'Andorre',
        Belgien: 'Belgique',
        Bulgarien: 'Bulgarie',
        Dänemark: 'Danemark',
        Estland: 'Estonie',
        Finnland: 'Finlande',
        Frankreich: 'France',
        Griechenland: 'Grèce',
        Irland: 'Irlande',
        Italien: 'Italie',
        Kroatien: 'Croatie',
        Lettland: 'Lettonie',
        Luxemburg: 'Luxembourg',
        Monaco: 'Monaco',
        Niederlande: 'Pays-Bas',
        Norwegen: 'Norvège',
        Polen: 'Pologne',
        Portugal: 'Portugal',
        'San Marino': 'Saint-Marin',
        Schweden: 'Suède',
        Slowakei: 'Slovaquie',
        Slowenien: 'Slovénie',
        Spanien: 'Espagne',
        'Tschechische Republik': 'République Tchèque',
        Ungarn: 'Hongrie',
        Vatikanstadt: 'Vatican',
        'Vereinigtes Königreich': 'Royaume-Uni',
        Zypern: 'Chypre',
        Kosovo: 'Kosovo',
        Litauen: 'Lituanie',
        Malta: 'Malte',
        Rumänien: 'Roumanie',
        Albanien: 'Albanie',
        'Bosnien und Herzegowina': 'Bosnie-Herzégovine',
        Liechtenstein: 'Liechtenstein',
        Mazedonien: 'Macédoine',
        Moldau: 'Moldavie',
        Montenegro: 'Monténégro',
        Serbien: 'Serbie',
        'Vereinigte Staaten': 'États-Unis',
        'Zone 1': 'Zone 1',
        'Zone 2': 'Zone 2',
        'Zone 3': 'Zone 3',
        'Zone 4': 'Zone 4',
    },
    codeToCountry: {
        AE: 'Émirats arabes unis',
        AT: 'Autriche',
        BE: 'Belgique',
        BG: 'Bulgarie',
        CY: 'Chypre',
        CZ: 'Tchéquie',
        DE: 'Allemagne',
        DK: 'Danemark',
        EE: 'Estonie',
        EL: 'Grèce',
        ES: 'Espagne',
        FI: 'Finlande',
        FR: 'France',
        GR: 'Grèce',
        HR: 'Croatie',
        HU: 'Hongrie',
        IE: 'Irlande',
        IT: 'Italie',
        LT: 'Lituanie',
        LU: 'Luxembourg',
        LV: 'Lettonie',
        MT: 'Malte',
        NL: 'Pays-Bas',
        PL: 'Pologne',
        PT: 'Portugal',
        RO: 'Roumanie',
        SE: 'Suède',
        SI: 'Slovénie',
        SK: 'Slovaquie',
        GB: 'Royaume-Uni',
        CH: 'Suisse',
        NO: 'Norvège',
        US: 'États-Unis',
    },
    shippingTable: {
        canvas: 'Toile',
        poster: 'Affiche',
        basePrice: 'Prix de base',
        perAdditionalProduct: 'Par produit supplémentaire',
    },
    time: {
        today: "Aujourd'hui",
        nDaysAgo: 'Il y a {n} jours',
        '1DayAgo': 'Il y a 1 jour',
    },
    unitSystems: {
        metric: 'cm/ml (Métrique)',
        imperial: 'inch/oz (Impérial)',
        both: 'cm + inch (Les deux)',
    },
    shoeSizeSystem: {
        eu: 'EU',
        us: 'US',
        uk: 'UK',
    },
    affiliateProgram: {
        title: "Programme d'affiliation",
        activeShopsLastYear: "Boutiques de moins d'un an",
        allShops: 'Tous les magasins',
        payouts: 'Paiements',
        payoutDate: 'Date de paiement',
        payoutAmount: 'Montant de paiement',
        payoutStatus: 'Statut du paiement',
        btnDownloadPayout: 'Télécharger le paiement',
        payoutInfo: 'Informations de paiement',
        paymentServiceProvider: 'Service de paiement',
        billingAgreement: 'Accord de facturation',
        deposited: 'Déposé',
        addNewPaymentMethod: 'Ajouter un nouveau mode de paiement',
        changePaymentMethod: 'Changer le mode de paiement',
        tryAgain: 'Réessayer',
        popup: 'Veuillez autoriser la fenêtre pop-up pour stocker vos données de paiement',
        selectPayment: 'Veuillez choisir',
        paypal: 'PayPal',
        creditCard: 'Carte de crédit',
        billingAddress: 'Adresse de facturation',
        paymentStatus: {
            open: 'Ouvert',
            invoice_upload_pending: 'Téléchargement de la facture',
            invoice_being_verified: 'Vérification de la facture',
            payment_pending: 'Paiement en attente',
            paid: 'Payé',
            failed: 'Échoué',
        },
    },
    marketPrintSolutions: {
        title: 'MarketPrint Solutions',
        returnmanagement: 'Gestion des retours',
        itemOverview: 'Aperçu des articles',
        subscription: 'Abonnement',
        bundling: 'Regroupement (bientôt disponible)',
    },
    betaFeatures: {
        workInProgress: 'Fonctionnalité en cours de développement',
        comingSoon: 'Bientôt disponible',
    },
    wallet: {
        title: 'Portefeuille',
        balance: 'Solde',
        activate: 'Activer le portefeuille',
        activateHint:
            'Activez le portefeuille pour cette région afin de le recharger par virement bancaire et de payer automatiquement les commandes avec.',
        activationRequirementHint: 'Pas encore disponible : {orderCount} sur {requiredOrderCount} commandes requises au cours des 90 derniers jours.',
        payout: 'Demander un paiement',
        payoutRequested: 'Paiement demandé avec succès',
        payoutFailed: 'La demande de paiement a échoué. Veuillez réessayer.',
        payoutConfirm:
            "L'intégralité du solde du portefeuille sera versée sur votre compte bancaire. Vous recevrez ensuite un e-mail avec les instructions exactes. Voulez-vous continuer ?",
        tableHeaders: {
            date: 'Date',
            description: 'Description',
            invoiceNumber: 'Facture',
            amount: 'Montant',
            status: 'Statut',
        },
        fundingTitle: 'Instructions de financement',
        fundingAccountHolder: 'Titulaire du compte',
        fundingAccountNumber: 'Numéro de compte',
        fundingSortCode: 'Code guichet',
        fundingRoutingNumber: 'Numéro de routage',
        fundingSwiftCode: 'SWIFT/BIC',
        fundingBankName: 'Banque',
        fundingNetworkAba: 'National (ACH / virement)',
        fundingNetworkSwift: 'International (SWIFT)',
        fundingHint:
            "Ces coordonnées bancaires appartiennent à notre prestataire de paiement (Stripe) et servent uniquement à recharger le solde de votre portefeuille – pas directement à MarketPrint. Veuillez virer exactement au titulaire du compte et à l'IBAN indiqués ; le montant sera automatiquement crédité sur votre portefeuille.",
        transactions: 'Transactions',
        viewTransactions: 'Voir les transactions',
        methodOrderTitle: 'Ordre des moyens de paiement',
        methodOrderSaved: 'Ordre des moyens de paiement enregistré',
        noMethodsActive: 'Aucun moyen de paiement actif',
        notConfigured: 'non configuré',
        methodActivate: 'Activer',
        methodDeactivate: 'Désactiver',
        lastMethodHint: 'Au moins un moyen de paiement doit rester actif.',
        moveUp: 'Monter',
        moveDown: 'Descendre',
        status: {
            completed: 'Terminé',
            failed: 'Échoué',
            pending: 'En attente',
        },
        methods: {
            wallet: 'Portefeuille',
            credit_card: 'Carte de crédit',
            paypal: 'PayPal',
        },
        notifications: {
            title: 'Wallet',
            lowBalance: "M'avertir par e-mail en cas de solde faible",
            threshold: 'Seuil',
            thresholdHint: 'Si votre solde passe en dessous de ce montant, vous serez averti par e-mail. Minimum : 30.',
            funding: "M'avertir par e-mail en cas de dépôt",
            notActiveWarning: "Le portefeuille n'est actuellement pas le moyen de paiement actif pour cette région.",
        },
        descriptionKey: {
            order_debit: 'Débit pour la commande {orderReference}',
            order_refund: 'Remboursement pour la commande {orderReference}',
            stripe_bank_transfer: 'Virement SEPA de {senderName}',
            payout_expired: 'Paiement expiré — solde recrédité (Remboursement {refundId})',
            payout_pending: 'Paiement vers le compte bancaire demandé',
            payout_completed: 'Paiement vers le compte bancaire effectué',
            payout_failed: 'Paiement vers le compte bancaire échoué',
            payout_reversed: 'Paiement échoué, montant recrédité ({errorMessage})',
            fallback: '{description}',
        },
    },
};

export default app;
